import {Injectable} from '@angular/core';
import { IQualificationDef } from 'src/app/model/view/iqualification-def';
import { SyllabusService } from '../syllabus/syllabus.service';
import { QualificationDefinitions } from './qualification-definitions';

@Injectable()
export class QualificationRepositoryService {

  constructor(private service: SyllabusService) {
  }

  public get vocational(): IQualificationDef[] {
    return [
      QualificationDefinitions.UPPER_SECONDARY_EDUCATION(this.service, true),
      QualificationDefinitions.GYAN(this.service, true),
      QualificationDefinitions.VUXGYAN(this.service, true),
      QualificationDefinitions.ADULT_SECONDARY_EDUCATION(this.service, true),
    ];
  }

  public get other(): IQualificationDef[] {
    return [
      QualificationDefinitions.COMPULSORY_SCHOOL(this.service),
      QualificationDefinitions.SAMI_SCHOOL(this.service),
      QualificationDefinitions.PRE_SCHOOL(this.service),
      QualificationDefinitions.PRE_SCHOOL_CLASS(this.service),
      QualificationDefinitions.LEISURE_TIME_CENTER(this.service),
      QualificationDefinitions.SWEDISH_FOR_IMMIGRANTS(this.service),
      QualificationDefinitions.GRINT(this.service),
      QualificationDefinitions.BASIC_ADULT_EDUCATION(this.service),
      QualificationDefinitions.ADULT_SECONDARY_EDUCATION(this.service, false),
      QualificationDefinitions.SPECIAL_SCHOOL_FOR_PUPILS_WITH_IMPAIRED_HEARING(this.service),
      QualificationDefinitions.TRGRAN(this.service),
      QualificationDefinitions.GRAN(this.service),
      //QualificationDefinitions.GYAN(this.service, false),
      QualificationDefinitions.GYANIND(this.service),
      QualificationDefinitions.UPPER_SECONDARY_EDUCATION(this.service, false),
      QualificationDefinitions.VUSGRAN(this.service),
      QualificationDefinitions.VUXGRAN(this.service),
      //QualificationDefinitions.VUXGYAN(this.service, false),

    ];
  }
}
